<div class="pt-6" id="topContainer">
    <div class="p-2 ">
        <h3 [ngClass]="'text-'+globals.colorTheme">
            <i class=" material-icons">settings</i>
            Settings</h3>
    </div>
</div>

<div class="container-fluid">
    <div class="row d-none">
        <div class="col-sm-12">
            <h5 class="text-left ml-3 ">User Profile</h5>
            <mat-divider></mat-divider>
            <br>
            <span>
                <mat-form-field floatLabel="never">
                    <input class="ta-settings-url" matInput type="string" placeholder="Url" [(ngModel)]="settings.url" disabled=false>
                </mat-form-field>
            </span>

            <span>
                <mat-form-field floatLabel="never">
                    <input matInput type="string" placeholder="Profile Name" [(ngModel)]="settings.profileName"
                        disabled=false>
                </mat-form-field>
            </span>

            <span>
                <mat-form-field floatLabel="never">
                    <input matInput type="string" placeholder="User ID" [(ngModel)]="settings.userId" disabled=false>
                </mat-form-field>
            </span>


            <span>
                <mat-form-field floatLabel="never">
                    <input matInput type="string" placeholder="Password" [(ngModel)]="settings.password" disabled=false>
                </mat-form-field>
            </span>

        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <br>
            <h5 class="text-left ml-3 ">Merchant Profile</h5>
            <mat-divider></mat-divider>
            <br>
            <div class="d-none">
                <mat-form-field floatLabel="never">
                    <input matInput type="string" placeholder="DataSet No" [(ngModel)]="settings.dataSetNo"
                        disabled=false>
                </mat-form-field>
            </div>

            <div class="d-none">
                <mat-form-field floatLabel="never">
                    <input matInput type="string" placeholder="Types" [(ngModel)]="settings.types" disabled=false>
                </mat-form-field>
            </div>

            <div formcontrolname infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50">
                <mat-form-field class="w-100" floatPlaceholder="never">
                    <mat-label>Location Code</mat-label>
                    <input matInput [matAutocomplete]="auto" class="ta-settings-locationcode" (input)="searchText()" [formControl]="locationAutocomplete"
                        (click)="onFocus($event);" (blur)="onBlur($event);" data-hj-whitelist>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-spinner [style.display]="showSpinner ? 'block' : 'none'"></mat-spinner>
                        <mat-option [style.display]="showSpinner ?  'none':'block' "
                            *ngFor="let settings of filteredLocations | async" [value]="settings.code" [ngClass]="'ta-settings-location-' + settings.code.toLowerCase()"
                            (onSelectionChange)="getitem($event, settings)">
                            <span>{{ settings.code }}</span> |
                            <small>{{settings.description}}</small>
                            <!-- (onSelectionChange)="selected($event, country)" -->
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
            <div>
                <mat-slide-toggle [(ngModel)]="settings.showQuantityOfAllLocations" class="ta-settings-quantityonhandforall"
                    checked="settings.showQuantityOfAllLocations">Show
                    Quantity on Hand for all locations </mat-slide-toggle>
            </div>
            <br>
            <div>
                <mat-slide-toggle [(ngModel)]="settings.disableQuotesExpiry" class="ta-settings-disableQuotesExpiry"
                checked="settings.disableQuotesExpiry">Show expired quotes</mat-slide-toggle>
                <mat-form-field class="w-100">
                    <mat-label>Number of days after quotes expire</mat-label>
                    <input class="ta-settings-daysafterquotesexpire" matInput type="number" onlyNumber="true" min="0"  [max-length]="2" [(ngModel)]="settings.quotesExpiryDays"
                        disabled=false>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="w-100">
                    <mat-label>Number of customers in search result</mat-label>
                    <input class="ta-settings-numberofcustomersinsearchresult" matInput type="number" onlyNumber="true" min="0" [max-length]="2" placeholder="Number of customers in search result"
                        [(ngModel)]="settings.numberOfCustomersInSearchResult" disabled=false>
                </mat-form-field>
            </div>
            <div>
                <mat-form-field class="w-100">
                    <mat-label>Number of items in search result</mat-label>
                    <input class="ta-settings-numberofitemsinsearchtresult" matInput type="number" onlyNumber="true" min="0" [max-length]="2"  placeholder="Number of items in search result"
                        [(ngModel)]="settings.numberOfItemsInSearchResult" disabled=false>
                </mat-form-field>
            </div>
            <div>
                <label>Note: The higher the number will slow displayed results </label>
            </div>
            <div>
                <mat-form-field class="w-100">
                    <mat-label>CC Email for print</mat-label>
                    <input class="ta-settings-cc-email" matInput type="email" placeholder="Email"
                        [(ngModel)]="settings.ccEmail">
                </mat-form-field>
            </div>
            <br>
            <div>
                <button type="button" class="btn btn-primary btn-lg btn-block ta-settings-nameidtyperange"
                    (click)="openNameIdTypeDialog()">{{changeNameIdTypeText}}</button>
            </div>
            <br>
            <div class="form-control text-right" style="border:none;">
                <button mat-button class="mat-mdc-button-RedBackground-WhiteText magin_5 text-white btn btn-danger ta-settings-reset" (click)="clearFields()">Reset</button>
                <button mat-button [disabled]="!validateTransaction()"
                    [ngClass]="'ta-settings-save magin_5 text-white btn btn-'+globals.colorTheme" (click)="saveSettings()">Save</button>
            </div>
            <br>
            <br>
        </div>
    </div>
</div>